export default {
    signatory: 999,
    letterlink: 888,
};